import React, { useContext, useEffect } from "react";
import OnlineClassTypesCarousel from "./OnlineClassTypesCarousel";
import { ClassTypeContext } from "../../context/ClassTypesContext";

export default function LandingOnlineClassTypes() {
  const { class_types, getClassTypes } = useContext(ClassTypeContext);

  useEffect(() => {
    getClassTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      id="disciplinas"
      className="container-fluid px-0 online__class-types position-relative animate-fade-in "
    >
      <div className="container-fluid">
        <h2 className="class-types__title">
          Un solo espacio. 10 disciplinas. Más de 800 clases.
        </h2>
        <p className="class-types__desc" style={{ paddingBottom: 30 }}>
          {" "}
          Clases estructuradas, coaches expertas y diferentes duraciones para
          que entrenes según tus objetivos, disfrutes el proceso y lo adaptes a
          tu ritmo.
        </p>
      </div>
      <OnlineClassTypesCarousel
        class_types={class_types?.filter(
          (class_type) => class_type.branch_id === 1,
        )}
      />
    </div>
  );
}
